import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWorkflowShapes12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconWorkflowShapes12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.707.377a1 1 0 0 0-1.414 0L6.879 1.79a1 1 0 0 0-.16.209H4.732A2 2 0 1 0 2 4.732V7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H3V5a2 2 0 0 0 2-2h1.72q.065.11.159.205L8.293 4.62q.095.095.207.159v2.284a2 2 0 1 0 1 0V4.779q.112-.064.207-.16l1.414-1.414a1 1 0 0 0 0-1.414zM9 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-5 2V8H2v2zM3 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7.414-1.502L9 1.084 7.586 2.498 9 3.912z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWorkflowShapes12);
